<template>
  <!-- ログインフォーム -->
  <div class="p-login-form">
    <login-form-title text="パスワードを変更してください" />
    <form id="passwordResetForm" :action="resetUrl">
      <ul class="p-login-form-list">
        <li class="p-login-form-list__item">
          <div class="c-input">
            <div class="c-input__title">登録されているメールアドレス</div>
            <input-mail :with-error-message="true" name="email" />
          </div>
        </li>
        <li class="p-login-form-list__item">
          <div class="c-input">
            <div class="c-input__title">新しいパスワード</div>
            <input-password :with-error-message="true" place-holder="新しいパスワードを入力してください" name="password" />
          </div>
        </li>

        <li class="p-login-form-list__item">
          <div class="c-input">
            <div class="c-input__title">新しいパスワード（確認）</div>
            <input-password :with-error-message="true" place-holder="確認のため、再度入力してください" name="password_confirmation" />
          </div>
          <ul class="p-login-form-suppl-list">
            <li class="p-login-form-suppl-list__item">パスワードは数字、英字大・小、記号(.+/-!?_#@)から2種類以上組み合わせて入力してください</li>
            <li class="p-login-form-suppl-list__item">パスワードは6文字以上32文字以下で入力してください</li>
          </ul>
        </li>
      </ul>
      <ul class="p-login-form-list p-login-form-list--bottom">
        <li class="p-login-form-list__item">
          <a class="c-btn c-btn--blue u-w250" href="#" @click="changePassword">
            <p class="c-btn__text">パスワードを変更する</p>
          </a>
        </li>
      </ul>
    </form>
  </div>
  <!-- /ログインフォーム -->
</template>

<script>
import axios from 'axios';

export default {
  props: {
    resetUrl: String,
    token: String,
  },
  methods: {
    changePassword: function (event) {
      event.preventDefault();

      var changeButton = $('button[name="change"]');
      var passwordResetForm = $('#passwordResetForm');

      // ローディング表示設定
      changeButton.addClass('is-loading').prop('disabled', 'disabled');

      // フォーム要素取得
      const data = {
        email: passwordResetForm.find('input[name=email]').prop('value'),
        password: passwordResetForm.find('input[name=password]').prop('value'),
        password_confirmation: passwordResetForm.find('input[name=password_confirmation]').prop('value'),
        token: this.token,
      };

      // 配信状況データの取得処理実行
      axios.post(passwordResetForm.prop('action'),data)
        .then(res => {
          if(res.data.result == 'OK'){
            location.href = "/coins-admin";
          } else {
            changeButton.removeClass('is-loading').prop('disabled', '');
            if(res.data.errors){
              for (let elementName in res.data.errors) {
                let message = res.data.errors[elementName];

                // エラーメッセージ表示設定
                passwordResetForm.find('input[name=' + elementName + ']')
                  .closest('li')
                  .find('.c-input__text')
                  .text(message)
                  .addClass('is-active');
              }
            }
          }
        })
        .catch(_e => {
          // エラーメッセージ表示設定
          passwordResetForm.find('input[name=password]')
            .closest('li')
            .find('.c-input__text')
            .text('予期せぬエラーが発生しました')
            .addClass('is-active');
        });
    },
  },
}
</script>
